import useStrings from "./useStrings";
import Helpers from "../commons/helpers";
import GroupService from "../services/identity/group.service";

import { Status } from "../constants/enums";
import { ICodename } from "../commons/interfaces";
import { RoleHelpers } from "../commons/roleHelpers";
import { useCommonComponentContext } from "../providers/CommonComponentProvider";



const useContainerGroup = () => {
    const Strings = useStrings();

    const {
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const checkGeneByGroup = (query: {
        gene: any,
        roleType: number,
        organizationId: string,
        listGroupSlice: ICodename[],
    }) => {
        if (
            RoleHelpers.isOrganizationGroupAdmin(query.roleType)
            || RoleHelpers.isOrganizationMember(query.roleType)
            || RoleHelpers.isOrganizationCustom(query.roleType)
            || RoleHelpers.isOrganizationDefault(query.roleType)
        ) {
            const index = query.listGroupSlice.findIndex((e) => (
                `${query.gene}`.startsWith(`${e.detail?.gene}`) &&
                (e.detail?.organizationId === query.organizationId)
            ));
            return (index !== -1);
        } else {
            return true;
        }
    }

    const getAllDataGroup = async (params: {
        clientId?: string,
        listStatus?: number[],
        organizationId?: string,
        includeCompany?: boolean,
    }) => {
        try {
            let listGroupTemp: ICodename[] = [];
            const result = await GroupService.getAll({
                clientId: params.clientId,
                listStatus: params.listStatus,
                organizationId: params.organizationId,
                includeCompany: params.includeCompany,
            });

            [...result || []].forEach((item: any) => {
                listGroupTemp.push({
                    code: item.id,
                    name: item.name,
                    detail: {
                        type: item.type,
                        gene: item.gene,
                        groupCode: item.groupCode,
                    }
                });
            });

            return listGroupTemp;
        } catch (error) { return []; }
    }

    const handleDeleteGroup = (props: {
        lable?: string;
        onCallBack?: () => void;
        params: {
            id: string,
            childNumber: number,
        }
    }) => {
        const messageAlert = (props.params?.childNumber === 0)
            ? Strings.format(Strings.Group.CONFIRM_DELETE, props.lable)
            : Strings.format(Strings.Group.CONFIRM_DELETE_WHEN_HAVE_CHILD_GROUP, props.lable, props.lable);

        Helpers.showConfirmAlert(messageAlert, async () => {
            try {
                onShowLoading();

                await GroupService.delete(props.params?.id);

                props.onCallBack && props.onCallBack();

                onSuccess(Strings.format(Strings.Group.DELETE_SUCCESS, props.lable));

            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        });
    };

    const handleChangeStatusGroup = (props: {
        lable?: string;
        onCallBack?: () => void;
        params: {
            id: string,
            status: number,
            organizationId: string,
        }
    }
    ) => {
        const messageAlert = (Number(props.params?.status) === Status.Active)
            ? Strings.Organization.CONFIRM_IN_ACTIVE_STATUS
            : Strings.Organization.CONFIRM_ACTIVE_STATUS;

        Helpers.showConfirmAlert(messageAlert, async () => {
            try {
                onShowLoading();

                await GroupService.updateStatus({
                    groupId: props.params?.id,
                    organizationId: props.params?.organizationId,
                    isActive: (props.params.status === Status.Active) ? false : true,
                });

                props.onCallBack && props.onCallBack();

                const messageSuccess = (props.params?.status === Status.Active)
                    ? Strings.Organization.IN_ACTIVE_STATUS_SUCCESS
                    : Strings.Organization.ACTIVE_STATUS_SUCCESS;

                onSuccess(messageSuccess);

            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        });
    };

    return {
        getAllDataGroup,
        checkGeneByGroup,
        handleDeleteGroup,
        handleChangeStatusGroup,
    };
}

export default useContainerGroup;